import { createElement, memo } from '@max/max';
import View from '@hfe/max-view';
import Text from '@hfe/max-text';
import './index.scss';
import { BizLineDesc } from '../../types/rewardRecords';
import Button from '@hfe/max-button';
import Image from '@hfe/max-image';
import NoticeSlider from '../notice-slider';
import { formatTimestamp } from '../../utils/time';
import { fenToYuan } from '../../utils/price';
import { parseFreeOrderCardExtra } from '../../utils/rewardRecords';
import { getPriceFontFamily } from '../../utils/style';
import LinearGradient from '@hfe/max-linear-gradient';
const priceFontFamily = getPriceFontFamily();
function FreeOrderMainCard(props) {
    const { currentCityName, rewardItem, onUseClick, activityId, cityExploreViewModel, feConfig } = props;
    const { styleConfig } = feConfig ?? {};
    const freeOrderInfo = parseFreeOrderCardExtra(rewardItem) ?? {};
    const bindBizName = freeOrderInfo?.bindOrderId && freeOrderInfo.bindBizLine ? BizLineDesc?.[freeOrderInfo?.bindBizLine] : '';
    const endTimeStamp = formatTimestamp(cityExploreViewModel.endTime, 'chinese');
    const yuanPrice = fenToYuan(freeOrderInfo.amount);
    return <>
      <View x-if={!freeOrderInfo?.bindOrderId} style={{
        backgroundColor: styleConfig?.backgroundColor
    }} className="unused-free-order-main-card__container">
        <LinearGradient colors={[styleConfig?.cardStartColor, styleConfig?.cardEndColor]} className="unused-free-order-main-card__background"/>
        <View className="unused-free-order-main-card__wrapper">
          <View className="unused-free-order-main-card__city-wrapper">
            <Image className="unused-free-order-main-card__city-img" source={{
        uri: 'https://img.meituan.net/makerjiulv/64dfa6ca2091992c588044e2e30be8e71727.png'
    }}/>
            <Text className="unused-free-order-main-card__city-text">心动城市：{props.currentCityName}</Text>
          </View>
          <View className="unused-free-order-main-card__title-wrapper">
            <Text className="unused-free-order-main-card__title-text">酒旅免单卡 最高免单</Text>
          </View>
          <View className="unused-free-order-main-card__amount-wrapper">
            <Text className="unused-free-order-main-card__amount-prefix" style={{
        fontFamily: priceFontFamily
    }}>
              ¥
            </Text>
            <Text className="unused-free-order-main-card__amount-content" style={{
        fontFamily: priceFontFamily
    }}>
              {yuanPrice}
            </Text>
          </View>
          <View className="unused-free-order-main-card__expire-desc-wrapper">
            <Text x-if={endTimeStamp} className="unused-free-order-main-card__expire-desc-text">
              有效期: {endTimeStamp}
            </Text>
          </View>
          <Button className="unused-free-order-main-card__use-button" onPress={onUseClick}>
            <Text className="unused-free-order-main-card__use-button-text">立即使用</Text>
          </Button>
          <View className="unused-free-order-main-card__notice-slider-wrapper">
            <NoticeSlider activityId={props.activityId}/>
          </View>
        </View>
      </View>
      <View x-if={freeOrderInfo?.bindOrderId} className="used-free-order-main-card__container" style={{
        backgroundColor: styleConfig?.backgroundColor
    }}>
        <LinearGradient className="used-free-order-main-card__background" colors={[styleConfig?.cardStartColor, styleConfig?.cardEndColor]}/>
        <View className="used-free-order-main-card__wrapper">
          <View className="used-free-order-main-card__tag-wrapper">
            <Image className="used-free-order-main-card__tag-img" source={{
        uri: 'https://p0.meituan.net/ingee/8d4c89471ad83c804fd872d7294252f120582.png'
    }}/>
          </View>
          <View className="used-free-order-main-card__left-wrapper">
            <Text className="used-free-order-main-card__left-title-text" numberOfLines={2}>{`免单${bindBizName}: ${freeOrderInfo?.bindName}`}</Text>
            <Text className="used-free-order-main-card__left-desc-text" numberOfLines={1}>
              离店后5个工作日返至【我的-余额】
            </Text>
          </View>
          <View className="used-free-order-main-card__amount-wrapper">
            <Text className="used-free-order-main-card__amount-prefix" style={{
        fontFamily: priceFontFamily
    }}>
              ¥
            </Text>
            <Text className="used-free-order-main-card__amount-content" style={{
        fontFamily: priceFontFamily
    }}>
              {yuanPrice}
            </Text>
          </View>
        </View>
      </View>
    </>;
}
export default memo(FreeOrderMainCard);
